<style lang="scss">
.button-wrapper{
  cursor: pointer;
}
</style>

<template>
  <div class="button-wrapper">
        <span v-if="videoId != null && videoId != ''" @click="showVideo = !showVideo" class="play-button"></span>
      <video-modal :video-id="videoId" :open="showVideo" @close="close"></video-modal>
  </div>
</template>

<script>
export default {
  props: {
    videoId: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      showVideo: false,
    };
  },

  methods: {
    close() {
      this.showVideo = false;
    },
  },
};
</script>
